import React, {useMemo} from 'react';

import {ReviewFeedback} from 'src/modules/ai/change-request-review/review-feedback/view/review-feedback';
import {getChangeRequestReview} from 'src/modules/ai/change-request-review/services';
import {useAppSelector} from 'src/store';

type Props = {
    changeRequestId: number | null | undefined,
    fieldName: string,
};

export const EventReviewFeedback = ({changeRequestId, fieldName}: Props) => {
    const changeRequestReview = useAppSelector(getChangeRequestReview)?.[changeRequestId || 0];

    const fildReview = useMemo(() => {
        return changeRequestReview?.eventFieldsReviews.find(attr => attr.fieldName === fieldName);
    }, [changeRequestReview, fieldName]);

    return (
        <>
            {fildReview ? (
                <ReviewFeedback verticalOffset={25} field={fildReview}/>
            ) : null}
        </>
    );
};
